module.exports = __webpack_public_path__ + "img/expand-vertical-3.eb90e97c.svg";